export default "__VITE_ASSET__4c97bedc__"